.wrapper {
  position: relative;
}

.btn {
  background: none;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  padding: 6px 10px;
  line-height: 1.4;
  white-space: nowrap;
  font-family: inherit;
  transition: border-color 0.2s, color 0.2s;
}

.btn:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.dropdown {
  position: fixed;
  z-index: 200;
  background-color: var(--color-bg-primary);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  box-shadow: var(--color-shadow-card);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  min-width: 160px;
  max-height: 320px;
  overflow-y: auto;
}

.item {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 8px 14px;
  cursor: pointer;
  color: var(--color-text-primary);
  font-size: 0.875rem;
  font-family: inherit;
  transition: background-color 0.15s;
}

.item:hover:not(:disabled) {
  background-color: var(--color-bg-tertiary);
}

.itemActive {
  font-weight: 600;
  color: var(--color-accent);
}

.itemDisabled {
  opacity: 0.45;
  cursor: default;
}
